/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    UntypedFormBuilder,
    ValidationErrors,
    ValidatorFn
} from '@angular/forms';
import {NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {
    merge,
    Observable,
    of
} from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    switchMap
} from 'rxjs/operators';
import {InputDropdownBase} from '../input-dropdown-base/input-dropdown-base';

@Component({
    selector: 'app-input-dropdown',
    templateUrl: './input-dropdown.component.html',
    styleUrls: [
        '../input/input.component.css',
        './input-dropdown.component.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
// Class must implement lifecycle hooks because it is metadata for Angular
export class InputDropdownComponent extends InputDropdownBase implements OnInit, OnDestroy {
    @Input() inputFormatter: NgbTypeahead['inputFormatter'];
    @Input() resultFormatter: NgbTypeahead['resultFormatter'];
    @Input() resultIsString = false;
    @Input() staticSectionText: string;
    @Input() dropdownTextOptionsNotBold: boolean;

    @ViewChild('dropdown') dropdown: NgbTypeahead;

    protected readonly DEBOUNCE_TIME = 300;

    get formattedSectionText(): string {
        let text: string = this.staticSectionText;
        if (this.staticSectionText === undefined) {
            text = null;
        } else if (this.staticSectionText === null) {
            text = '-';
        }
        return text;
    }

    get emptySectionCss(): string {
        return this.staticSectionText != null ? null : 'empty';
    }

    get dropdownTextNotBold(): string {
        return this.dropdownTextOptionsNotBold ? 'input-dropdown-option-text-not-bold' : null;
    }

    constructor(protected formBuilder: UntypedFormBuilder) {
        super(formBuilder);
    }

    @Input() resultsFunction = (term: string | Event): Observable<any[]> => of([]);

    dropdownValidator: ValidatorFn = (): ValidationErrors | null => {
        if (this.inputControl == null) {
            return null;
        }
        const value = this.inputControl.value;
        if (value == null || value === ''
                || (!this.resultIsString && value.constructor.name !== String.name)
                || (this.resultIsString && value.constructor.name === String.name)) {
            return null;
        }
        return {'incorrect': true};
    };

    ngOnInit(): void {
        super.ngOnInit();
        this.setInputValidator(this.dropdownValidator);
    }

    search = (text: Observable<string>): Observable<any[]> => {
        const debouncedText = text.pipe(debounceTime(this.DEBOUNCE_TIME), distinctUntilChanged());
        return merge(debouncedText, this.inputFocus)
                .pipe(distinctUntilChanged(), switchMap(this.resultsFunction));
    };

}

